import { useTRPC } from "@/trpc/client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

function invalidate(qc: ReturnType<typeof useQueryClient>) {
  qc.invalidateQueries({ queryKey: [["intelligence"]] });
  // Sending or syncing writes assessment sessions and bumps the member's
  // sessionCount, and those live under `salesTeams` (listSessions, getMember,
  // listMembers) - without this the member's profile keeps showing the list it
  // had before the invite was sent.
  qc.invalidateQueries({ queryKey: [["salesTeams"]] });
}

export function useEnsureProviderCampaign() {
  const trpc = useTRPC();
  return useMutation({
    ...trpc.intelligence.assessmentTests.ensureProviderCampaign.mutationOptions(),
  });
}

export function useCreateAssessmentInvites() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.intelligence.assessmentTests.createAssessmentInvites.mutationOptions(),
    onSuccess: () => invalidate(qc),
  });
}

export function useSyncAssessmentResults() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.intelligence.assessmentTests.syncResults.mutationOptions(),
    onSuccess: () => invalidate(qc),
  });
}
